<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          class="demo-ruleForm"
          :label-width="formLabelWidth"
        >
          <p>波次分播设置</p>
          <el-form-item label="开启自动结束分播:">
            <el-switch v-model="form.auto_close" @change="change1"> </el-switch>
            （开启后，当拣货明细=分播明细时，每隔5分钟进行自动结束分播相关拣货任务）
          </el-form-item>
          <el-form-item>
            <div slot="label">
              “未处理”备注的波次<span style="color: red">不可以</span>正常分播
            </div>
            <el-switch
              v-model="unHandleRemark"
              inactive-value="0"
              active-value="1"
              @change="changeUnHandleRemark"
            >
            </el-switch>
            （开启后，有备注且备注状态为“未处理”的中分位状态不能变为“去分播”、备注状态为“未处理”的波次将会被分播到异常格口、<span
              style="color: red"
              >PDA分播将报错</span
            >）
          </el-form-item>
          <el-form-item>
            <div slot="label">
              囤货标记的波次是否生成上架任务，且完成分播后提示上架
            </div>
            <el-switch
              v-model="stockRemark"
              :inactive-value="STOCK_REMARK.CLOSED"
              :active-value="STOCK_REMARK.OPEN"
              @change="changeStockRemark"
            >
            </el-switch>
            <span style="margin-left: 10px"
              >(开启后，有囤货标记的波次进行分播会生成囤货上架任务，且完成分播后需绑定容器)</span
            >
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs.vue";
import * as wavePicking from "@/controller/wavePicking.js";
import * as wavePickingApi from "@/openapi/erp/wavePicking.js";

const UNHANDLE_REMARK = {
  CLOSED: "0", // 备注生成新波次配置（0: 关闭）
  OPEN: "1", // 备注生成新波次配置（1:开启）
};
const STOCK_REMARK = {
  CLOSED: 0, // （0: 关闭）
  OPEN: 1, // （1:开启）
};

export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      STOCK_REMARK,
      UNHANDLE_REMARK,
      form: {
        auto_close: false,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/CutSetting",
      filterFold: false,
      supplyData: null,
      origin_txt: 1,
      formLabelWidth: "300px",
      unHandleRemark: UNHANDLE_REMARK.CLOSED, // 未处理波次是否可正常分播（0: 关闭，1:开启）
      stockRemark: STOCK_REMARK.CLOSED, // 囤货标记的波次是否生成上架任务（0: 关闭，1:开启）
    };
  },
  computed: {
    filteredForm() {
      Object.keys(this.form).forEach((key) => {
        if (!this.form[key]) {
          delete this.form[key];
        }
      });
      return this.form;
    },
  },
  mounted() {
    this.getUnHandleRemarkConfig();
    this.getStockWavePickingSwitch();
  },
  methods: {
    getStockWavePickingSwitch() {
      wavePickingApi.getGetStockWavePickingSwitch().then((res) => {
        const {
          stock_wave_picking_switch:
            stockWavePickingSwitch = STOCK_REMARK.CLOSED,
        } = res;
        this.stockRemark = stockWavePickingSwitch;
      });
    },
    setStockWavePickingSwitch() {
      wavePicking({
        stock_wave_picking_switch: this.stockRemark,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message.error(res.msg);
        } else {
          this.$message.success("修改成功");
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
        }
      });
    },
    change1($e) {
      this.onSubmit($e, 1);
    },
    onSubmit($e, type) {
      let msg = "";
      if (type == 1) {
        if ($e === true) {
          msg = "是否确认开启自动结束分播？";
        } else {
          msg = "是否确认关闭自动结束分播？";
        }
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.post(this.url, this.filteredForm).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          if (type == 1) {
            this.form.auto_close = !$e;
          }
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 获取 - 显示未处理备注的波次是否可以正常分播配置
    getUnHandleRemarkConfig() {
      wavePicking.getUnHandleRemarkConfig().then((res) => {
        this.unHandleRemark = res.un_handle_remark;
      });
    },
    // 设置 - 显示未处理备注的波次是否可以正常分播配置
    changeUnHandleRemark() {
      this.$confirm(
        "确定修改显示未处理备注的波次是否可以正常分播配置？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const postData = {
            un_handle_remark: this.unHandleRemark,
          };
          wavePicking.setUnHandleRemarkConfig(postData).then(() => {
            this.$message.success("修改成功");
          });
        })
        .catch(() => {
          this.unHandleRemark =
            this.unHandleRemark === UNHANDLE_REMARK.CLOSED
              ? UNHANDLE_REMARK.OPEN
              : UNHANDLE_REMARK.CLOSED;
        });
    },
    // 设置 - 囤货标记生成上架任务
    changeStockRemark(value) {
      const openTips =
        "有囤货标记的波次进行分播会生成囤货上架任务，且完成分播后需绑定容器。";
      const closeTips =
        "有囤货标记的波次进行分播不会，且完成分播后不需绑定容器";
      this.$confirm(
        value === STOCK_REMARK.OPEN ? openTips : closeTips,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          wavePickingApi
            .postSetStockWavePickingSwitch({
              stock_wave_picking_switch: value,
            })
            .then(() => {
              this.$message.success("修改成功");
            });
        })
        .catch(() => {
          this.stockRemark =
            this.stockRemark === STOCK_REMARK.CLOSED
              ? STOCK_REMARK.OPEN
              : STOCK_REMARK.CLOSED;
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/CutSetting.vue